let obj = {
    schoolId: '',
    checkItemStatus: "",
    schoolType: '',
    idNo: '',
    grade: "",
    classRoomNo: "",
    name: "",
    birthDate: "",
    age: "",
    sex: '0',
    studentId: "",
    contact: "",
    nationalityCode: '01',
    cxType: '0',
    checkDate: "",
    year: "",
    result: "",
    advice: "",


};

// for (let i = 1; i <= 100; i++) {
//
//
//     obj["p" + (i + "").padStart(3, "0")] = null;
//     obj["p" + (i + "").padStart(3, "0") + "Sub"] = null;
// }


export default obj;
